export const environment = {
  production: false,
  apiUrl:'https://api.ps.stage.billing-3ps-stage.awsnprd.external.telenet.be',
  oktaDomain: 'telenet-partners.oktapreview.com',
  oktaClientId: '0oa6y04l59YF8ZCXu0x7',
  issuerId: 'aus65hzs7788OWryG0x7',
  dynatraceUrl: 'https://dok.js-cdn.dynatrace.com/jstag/17fb5a5df08/bf80368yvv/6d19e178969499db_complete.js'
};
